export const GET_REGIONS = 'GET_REGIONS'
export const GET_PROVINCES = 'GET_PROVINCES'
export const GET_MUNICIPALITIES = 'GET_MUNICIPALITIES'
export const GET_BARANGAYS = 'GET_BARANGAYS'